var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayStart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_6447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5152 5.64511L7.75909 0.691024C7.2314 0.304618 6.60702 0.0718791 5.95515 0.0186057C5.30328 -0.0346676 4.6494 0.0936054 4.06597 0.389207C3.48254 0.684808 2.99236 1.13619 2.64977 1.69332C2.30717 2.25045 2.12554 2.89157 2.125 3.54561V13.4587C2.12399 14.1134 2.30467 14.7555 2.64694 15.3136C2.98921 15.8717 3.47964 16.3238 4.06364 16.6197C4.64764 16.9156 5.30229 17.0436 5.95473 16.9895C6.60717 16.9355 7.2318 16.7014 7.75909 16.3133L14.5152 11.3592C14.9635 11.0302 15.328 10.6003 15.5792 10.1043C15.8305 9.60823 15.9614 9.05999 15.9614 8.50394C15.9614 7.94789 15.8305 7.39965 15.5792 6.9036C15.328 6.40755 14.9635 5.97763 14.5152 5.64865V5.64511Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_6447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStart);
export default __webpack_public_path__ + "static/media/PlayStart.126a7ebfc442bb02be21bd34dad02f8a.svg";
export { ForwardRef as ReactComponent };